// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".r1_iframe_embed[data-v-78d84db8]{position:relative;overflow:hidden;width:300px;height:170px}.r1_iframe_embed[data-v-78d84db8] iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:0}.r1_iframe_embed[data-v-78d84db8] .iframe_loader{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%)}", ""]);
// Exports
module.exports = exports;
